import styles from './buttonIcon.module.css'

export default function ButtonIcon({ icon, titulo, ...props }) {
    return (
        <button className={styles.buttonIcon} {...props}>
            {icon}
            <span>{titulo}</span>
        </button>
    )
}
